.janeGoldSection {
  padding-left: var(--page-margin);
  padding-right: var(--page-margin);
}

.janeGoldSection:empty {
  display: none;
}

@media (--reefer-media-tablet-min) {
  .janeGoldSection {
    padding-left: var(--page-margin-desktop);
    padding-right: var(--page-margin-desktop);
  }
}
